import { formatThoughtForSecondsLabel } from '@/services/chatApi'
import { dedupeStrings } from '../appShell/backendRunProgressUtils'
import { RESPONSE_COMPONENT_DEMO_THOUGHT_DETAILS } from '../responseComponentDemoData'

/** @param {Record<string, unknown>} prev */
export function patchResponseComponentDemoMessage(prev, blocks) {
  const started =
    typeof prev.thinkingStartedAt === 'number' ? prev.thinkingStartedAt : prev.createdAt
  const thoughtDetails = dedupeStrings([
    ...(Array.isArray(prev.thoughtDetails) ? prev.thoughtDetails : []),
    ...RESPONSE_COMPONENT_DEMO_THOUGHT_DETAILS,
  ]).slice(-40)
  return {
    ...prev,
    text: 'RESPONSE_COMPONENT_DEMO',
    blocks,
    createdAt: Date.now(),
    agentBrand: 'SIA',
    agentName: 'Master Root Agent',
    thoughtSummary: formatThoughtForSecondsLabel(
      typeof started === 'number' ? started : Date.now(),
    ),
    thoughtDetails,
    autoExpandPreamble: false,
  }
}

export function updatePendingDemoMessage(setMessagesByThreadId, tid, pendingId, blocks) {
  setMessagesByThreadId((inner) => {
    const list = [...(inner[tid] ?? [])]
    const idx = list.findIndex((m) => m.id === pendingId)
    if (idx === -1) return inner
    const next = [...list]
    next[idx] = patchResponseComponentDemoMessage(list[idx], blocks)
    return { ...inner, [tid]: next }
  })
}
